// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gSAZSe {
  display: flex;
  flex-direction: column;
  margin: var(--spacing-3) 0;
  border-radius: 8px;
  background-color: var(--surface-neutral-white);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.swACfM {
  display: flex;
  flex-direction: row;
  flex-shrink: 0;
  gap: var(--spacing-1);
  padding: 0 var(--spacing-2) 0 var(--spacing-1-5);
  box-shadow: inset 0 -1px 0 var(--stroke-neutral-subtle);
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  scrollbar-width: none;
}

.swACfM::-webkit-scrollbar {
  display: none;
}

.grtyFf {
  padding: var(--spacing-1-5) var(--spacing-1);
  color: var(--text-neutral-dark);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  white-space: nowrap;
  border-bottom: 2px solid transparent;
  transition:
    color 0.15s,
    border-color 0.15s;
}

.grtyFf:hover,
.grtyFf:focus-visible {
  color: var(--text-primary-medium);
  outline: none;
}

.K8nO1c {
  color: var(--text-primary-medium, #d64000);
  border-bottom-color: var(--stroke-primary-medium, #d64000);
  font-weight: var(--font-weight-semibold);
}

.OqJUYr {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  min-width: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Financeiro/FinanceiroLayout.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,gDAAgD;EAChD,uDAAuD;EACvD,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC;;sBAEoB;AACtB;;AAEA;;EAEE,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,0DAA0D;EAC1D,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;AACd","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  margin: var(--spacing-3) 0;\n  border-radius: 8px;\n  background-color: var(--surface-neutral-white);\n  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.12);\n  overflow: hidden;\n}\n\n.navigation {\n  display: flex;\n  flex-direction: row;\n  flex-shrink: 0;\n  gap: var(--spacing-1);\n  padding: 0 var(--spacing-2) 0 var(--spacing-1-5);\n  box-shadow: inset 0 -1px 0 var(--stroke-neutral-subtle);\n  overflow-x: auto;\n  overscroll-behavior-inline: contain;\n  scrollbar-width: none;\n}\n\n.navigation::-webkit-scrollbar {\n  display: none;\n}\n\n.tab {\n  padding: var(--spacing-1-5) var(--spacing-1);\n  color: var(--text-neutral-dark);\n  font-size: var(--font-size-md);\n  font-weight: var(--font-weight-medium);\n  text-decoration: none;\n  white-space: nowrap;\n  border-bottom: 2px solid transparent;\n  transition:\n    color 0.15s,\n    border-color 0.15s;\n}\n\n.tab:hover,\n.tab:focus-visible {\n  color: var(--text-primary-medium);\n  outline: none;\n}\n\n.tabActive {\n  color: var(--text-primary-medium, #d64000);\n  border-bottom-color: var(--stroke-primary-medium, #d64000);\n  font-weight: var(--font-weight-semibold);\n}\n\n.content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  min-width: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `gSAZSe`,
	"navigation": `swACfM`,
	"tab": `grtyFf`,
	"tabActive": `K8nO1c`,
	"content": `OqJUYr`
};
module.exports = ___CSS_LOADER_EXPORT___;
